/* istanbul ignore file */
/**
 * Returns value of legacy language cookie.
 *
 * @param tenant
 * @returns
 */
export function getLegacyCookieName(tenant: string) {
  return `${tenant}_website#lang`;
}
